module.exports = __webpack_public_path__ + "static/contact-temp-b6195bc3334d46106ea6f7c0306794ba.jpg";